export default {
    name: 'card-accordion',
    props: {
        heading: String,
        text: String,
        subheading: String,
        tier: String,
        level: String,
        lozenge: String,
        id: String,
        image: String,
        isActive: Boolean,
    },
    methods: {
        handleClick() {
            if (this.$store) {
                this.$store.commit('updateActiveEntriesIds', { id: this.id });
            } else {
                this.$emit('toggle-active', this.id);
            }
        },
    },
    template: `
        <div class="card-accordion" :id="'card-' + id" :class="{'toggled' : isActive}">
            <div class="card-accordion__left" :class="{'card-accordion__left--with-tier' : tier}">
                <p v-if="lozenge" class="card-accordion__lozenge h6">{{ content.lozenge }}</p>
                <p v-if="subheading" class="h6 card-accordion__sub-heading">{{ subheading }}</p>
                <div class="card-accordion__tier-tag" :class="'card-accordion__tier-tag--' + tier" v-if="tier">
                    <span class="card-accordion__tier-name">{{ tier }}</span>
                </div>
                <img class="card-accordion__logo" v-if="image && isActive" :src="image" :alt="heading"/>
            </div>

            <div class="card-accordion__right">
                <p class="h4 card-accordion__heading">{{ heading }}</p>
                <div class="card-accordion__toggled-content">
                    <slot name="content">
                    </slot>
                </div>

                <div class="card-accordion__toggle expand" v-on:click="handleClick()">
                    <svg class="icon expand__plus-outline">
                        <use xlink:href="#plus-outline"/>
                    </svg>
                    <svg class="icon expand__plus-solid">
                        <use xlink:href="#plus-solid"/>
                    </svg>
                    <svg class="icon expand__minus-outline">
                        <use xlink:href="#minus-outline"/>
                    </svg>
                    <svg class="icon expand__minus-solid">
                        <use xlink:href="#minus-solid"/>
                    </svg>
                </div>
            </div>
        </div>
    `,
};
